// Base URL
const BASE_URL = '/certifications/v2/items';

// ARS URLs
export const URL_ARS_API = BASE_URL;

// Bulk action URLs
export const URL_SELECT_ALL_API = '/certifications/v2/items/selectAll';
export const URL_ADD_REMOVE_FROM_SESSION_API =
  '/certifications/v2/items/addRemoveFromSession';
export const URL_TREE_SELECT_ALL_API = '/certifications/v2/selectAll';
export const URL_BULK_UPDATE_API = '/certifications/v2/items/bulkUpdate';
export const URL_BULK_CONSULT_API = '/certifications/v2/items/bulkConsult';
export const URL_BULK_REASSIGN_API = BASE_URL;
export const URL_BULK_ACTION_PROGRESS_API =
  '/certifications/v2/items/bulkActionProgress';

// Export URLs
export const URL_EXPORT_OLD_API = BASE_URL;
export const URL_EXPORT_NEW_API = '/certifications/v2/export';
export const URL_GET_APPLIED_COLUMNS_FOR_EXPORT =
  '/certifications/v2/getAppliedFilters'; //  from certms

// Core URLs
export const URL_REFRESH_API = BASE_URL;
export const URL_ITEMS_API = BASE_URL;
export const URL_ES_CHECK_API = '/certifications/v2/checkEsConnection';
export const URL_VIEW_API = '/certifications/v2/items/view';
export const URL_UPDATE_FILTER_API = '/certifications/v2/updatefilter';
export const URL_CLEAR_FILTER_API = '/certifications/v2/items/clearFilter';
export const URL_FILTER_SEARCH_API =
  '/certifications/v2/items/uniqueRecordFilter';
export const URL_FETCH_USER_API = '/certifications/v2/fetchUserList';
export const URL_AUDIT_HISTORY_API = '/certifications/v2/items/auditHistory';
export const URL_APPLY_SAVED_USER_PREFERENCES_API =
  '/certifications/v2/applySavedUserPreferences';
export const URL_PREDEFINED_COMMENT_API =
  '/certifications/v2/getPredefinedComments';

// Global URLs
export const URL_COLUMN_PICKER_API =
  '/certifications/v2/fetchColumnsPickerList';

// Line Action URLs
export const URL_VERIFY_PARENT_API =
  '/certifications/v2/items/verifyParentItemStatus';
export const URL_REVOKE_ACTION_API = '/certifications/v2/items/revoke';
export const URL_APPROVE_ACTION_API = '/certifications/v2/items/approve';
export const URL_REJECT_ACTION_API = '/certifications/v2/items/reject';
export const URL_REASSIGN_ACTION_API = BASE_URL;
export const URL_CONSULT_ACTION_API = '/certifications/v2/items/consult';

// Linear Progress Bar URLs
export const URL_FETCH_PROGRESS_API =
  '/certifications/v2/items/fetchCertificationProgress';

// Personalization URLs
export const URL_GET_PERSONALIZATION_API =
  '/certifications/v2/getPersonalization';
export const URL_CREATE_PERSONALIZATION_API =
  '/certifications/v2/createPersonalization';
export const URL_UPDATE_PERSONALIZATION_API =
  '/certifications/v2/updatePersonalization';

// Review And Submit URLs
export const URL_LOCK_SUMMARY_API = '/certifications/v2/lockSummary';
export const URL_VALIDATE_SIGNATURE_API =
  '/certifications/v2/validateESignature';
export const URL_LOCK_API = '/certifications/v2/lock';
export const URL_LOCK_CONSULTEE_API = '/certifications/v2/completeConsult';

// Sidepanel URLs
export const URL_ENTITLEMENT_SUMMARY_API =
  '/certifications/v2/items/entitlementSummary';
export const URL_ENTITLEMENT_PRIVILEDGES_API =
  '/certifications/v2/items/entitlementPrivileges';
export const URL_ENTITLEMENT_SOD_API =
  '/certifications/v2/items/entitlementSOD';
export const URL_ENTITLEMENT_CHILD_API =
  '/certifications/v2/items/childEntitlements';
export const URL_ENTITLEMENT_MAPPED_API =
  '/certifications/v2/items/mappedEntitlements';
export const URL_ACCOUNT_SUMMARY_API =
  '/certifications/v2/items/accountSummary';
export const URL_USER_SUMARY_API = '/certifications/v2/items/userSummary';
export const URL_ROLE_SUMMARY_API = '/certifications/v2/items/roleSummary';
export const URL_ROLE_ENTITLEMENTS_API =
  '/certifications/v2/items/roleEntitlements';
export const URL_ROLE_CHILD_API = '/certifications/v2/items/childRoles';

// Savi Companion URLs
export const URL_SAVI_STATUS_API = '/certifications/v2/saviStatus';
export const URL_SAVI_APPLY_API = '/certifications/v2/applySaviActions';

// Tab URLs
export const URL_TAB_COUNT_API = '/certifications/v2/getTabCount';

// View Controls URLs
export const URL_CONTROLS_FILTER_API = '/certifications/v2/items/filters';
export const URL_SMART_CARD_API = '/certifications/v2/smartCardFilters';

// Exclusion list for Cert MS
export const URL_EXCLUSION_LIST_CERT_DETAILS_API = [
  URL_LOCK_CONSULTEE_API,
  '/certifications/v2/lock',
  '/certifications/v2/export',
  // '/exportCertification',
  // '/lockCertification',
  '/getEntitlementRequestHistory',
  '/getAccountRequestHistory',
  '/getRoleRequestHistory',
  '/certifications/v2/items/getEntitlementRequestHistory',
  '/certifications/v2/items/getAccountRequestHistory',
  '/certifications/v2/items/getRoleRequestHistory',
  // list page api's
  '/certifications/v2/listView',
  '/certifications/v2/listData',
  '/certifications/v2/listData?format=xls&extension=xls',
  '/certifications/v2/certificationSummary',
  '/certifications/v2/tabCountCertList',
  '/api/certifications/v2/discontinuecertification',
  '/api/certifications/v2/emailHistory',
  '/api/certifications/v2/items/sendNotifyEmail',
  '/certifications/v2/campaignProgressRefresh',
  '/certifications/v2/items/auditHistory',
  '/certifications/v2/fetchUserList',
];
